/**
 * @generated SignedSource<<45d74f9e04100cdec00379a7a9a448e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "folderId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InboxFolderThreadsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "folderId",
                "variableName": "folderId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "Inbox_folderThreadsViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InboxFolderThreadsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "items": [
                      {
                        "kind": "Variable",
                        "name": "folderIds.0",
                        "variableName": "folderId"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "folderIds"
                  }
                ],
                "concreteType": "ThreadConnection",
                "kind": "LinkedField",
                "name": "threads",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThreadEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Thread",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "threadId",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UserScope",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ed345b17153c6c6c0b57c09f6b2569f5",
    "id": null,
    "metadata": {},
    "name": "InboxFolderThreadsRefetchQuery",
    "operationKind": "query",
    "text": "query InboxFolderThreadsRefetchQuery(\n  $folderId: ID\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...Inbox_folderThreadsViewer_anm0i\n    id\n  }\n}\n\nfragment Inbox_folderThreadsViewer_anm0i on UserScope {\n  threads(folderIds: [$folderId], first: 1) {\n    edges {\n      node {\n        threadId\n        id\n      }\n    }\n  }\n  id\n}\n"
  }
};
})();

node.hash = "e0c281e408668c12e51c3a87c990e435";

module.exports = node;
